import type { FaireProductEntity } from "../../entity_types/product";

export const p_k4mqhkwcra: FaireProductEntity = {
  token: "p_k4mqhkwcra",
  type: "product",
  name: "Pave Gold Bar Necklace -Waterproof - NG037",
  brandToken: "b_dmzj4e52w6",
  brandName: "AAJewelry",
  imageUrl:
    "https://cdn.faire.com/fastly/bc1616ab07e17850e936d31645e265693f65b149ac9d4b39cf0ad028c0e32dcb.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/edcce024dc1da7e953f7471397995b601ecd32f75daf82763cdbd4a584e48a9e.jpeg",
    "https://cdn.faire.com/fastly/5d7a53155b614d265efd642ba0888421d897062fe0f91a8dd1412afe10945db9.jpeg",
    "https://cdn.faire.com/fastly/593a99a7c16d9c9eb9c716eaf3549ebd992e46fc5acc88a4eade064190ca7df3.jpeg",
    "https://cdn.faire.com/fastly/a7baef5f3adb294f3e1ead76fe4d5262ea0fa91ed6282689dabbf35154e65abe.jpeg",
    "https://cdn.faire.com/fastly/4e6c934de5796bb5fd688b35381fb5bb7f6d05937572ea9fc82ca79902d62166.jpeg",
  ],
  priceDollars: 16.63,
  description:
    'A sleek and modern gold vertical bar necklace featuring a slim drop pendant set with sparkling CZ diamond for a clean, refined shine. The delicate chain and minimalist bar design make it perfect for everyday wear, office styling, and effortless layering with your favorite necklaces.\n\nDesigned to sit beautifully at the collarbone, this dainty gold necklace adds just the right amount of sparkle without feeling heavy — simple, elegant, and timeless.\n\nPRODUCT QUALITY\nExpertly handcrafted from sterling silver and stainless steel, our jewelry features thick gold and rhodium plating for lasting shine. Finished with durable 18k PVD coating adding extra layers of genuine gold, each piece stays brilliant and resists daily wear for years to come.\n\nDETAILS\n▪ Necklace Length: 16.1" + 2" Ext   \n▪ Pendant: Length: 2.28mm\n• 5A High Quality Cubic Zirconia Diamond\n▪ Thick 18k gold plated - high-quality medical 316L stainless steel\n▪ Hypoallergenic ▪ Nickel-free ▪ Non tarnish ▪ Water Resistant',
  tags: [],
  msrpDollars: 33.26,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:57:54.493Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
